<template>
  <div class="my-footer">
    <div class="footer-placeholder"></div>
    <div class="footer-main">
      <img src="../assets/img/login_bottom.png" alt="" class="bottom-logo" />
    </div>
  </div>
</template>

<script>
export default {

}
</script>

<style lang="less" scoped>
.my-footer {
  .footer-placeholder {
    height: 180px;
  }

  .footer-main {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 50;
    height: 72px;
    background-color: white;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 -2px 16px 0 rgba(0,0,0,.12);
  }

  .bottom-logo {
    height:50px;
    width:auto;
  }
}

</style>
